import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './LegalPages.css';

const PrivacyPolicy = () => {
  const { t, i18n } = useTranslation('legal');
  const currentLang = i18n.language;

  return (
    <div className="legal-page">
      <header className="landing-page__header">
        <div className="landing-page__logo-container">
          <Link to={currentLang === 'fr' ? '/fr' : '/'}>
            <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="AIvatar Logo" className="landing-page__logo" />
          </Link>
        </div>
      </header>
      
      <main className="legal-page__content container">
        <h1>{t('privacy.title')}</h1>
        
        <section className="legal-page__section">
          <h2>{t('privacy.intro.title')}</h2>
          <p><strong>{t('company.name')}</strong>: BOCO<br />
          <strong>{t('company.rcs')}</strong>: 895311082<br />
          <strong>{t('company.status')}</strong>: {t('company.status_value')}<br />
          <strong>{t('company.siret')}</strong>: 89531108200021<br />
          <strong>{t('company.address')}</strong>: Les Catalas, 09700 Saverdun France<br />
          <strong>{t('company.phone')}</strong>: 0756835116<br />
          <strong>{t('company.email')}</strong>: contact@muware.xyz<br />
          <strong>{t('company.manager')}</strong>: contact@muware.xyz</p>
          
          <p>{t('privacy.intro.description')}</p>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('privacy.data.title')}</h2>
          
          <h3>{t('privacy.data.provided.title')}</h3>
          <ul>
            <li><strong>{t('privacy.data.provided.account.title')}</strong>: {t('privacy.data.provided.account.desc')}</li>
            <li><strong>{t('privacy.data.provided.payment.title')}</strong>: {t('privacy.data.provided.payment.desc')}</li>
            <li><strong>{t('privacy.data.provided.images.title')}</strong>: {t('privacy.data.provided.images.desc')}</li>
            <li><strong>{t('privacy.data.provided.communications.title')}</strong>: {t('privacy.data.provided.communications.desc')}</li>
          </ul>
          
          <h3>{t('privacy.data.automatic.title')}</h3>
          <ul>
            <li><strong>{t('privacy.data.automatic.usage.title')}</strong>: {t('privacy.data.automatic.usage.desc')}</li>
            <li><strong>{t('privacy.data.automatic.device.title')}</strong>: {t('privacy.data.automatic.device.desc')}</li>
            <li><strong>{t('privacy.data.automatic.cookies.title')}</strong>: {t('privacy.data.automatic.cookies.desc')}</li>
          </ul>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('privacy.usage.title')}</h2>
          
          <p>{t('privacy.usage.intro')}</p>
          
          <h3>{t('privacy.usage.service.title')}</h3>
          <ul>
            <li>{t('privacy.usage.service.item1')}</li>
            <li>{t('privacy.usage.service.item2')}</li>
            <li>{t('privacy.usage.service.item3')}</li>
            <li>{t('privacy.usage.service.item4')}</li>
            <li>{t('privacy.usage.service.item5')}</li>
          </ul>
          
          <h3>{t('privacy.usage.improve.title')}</h3>
          <ul>
            <li>{t('privacy.usage.improve.item1')}</li>
            <li>{t('privacy.usage.improve.item2')}</li>
            <li>{t('privacy.usage.improve.item3')}</li>
          </ul>
          
          <h3>{t('privacy.usage.marketing.title')}</h3>
          <ul>
            <li>{t('privacy.usage.marketing.item1')}</li>
            <li>{t('privacy.usage.marketing.item2')}</li>
            <li>{t('privacy.usage.marketing.item3')}</li>
          </ul>
          
          <h3>{t('privacy.usage.security.title')}</h3>
          <ul>
            <li>{t('privacy.usage.security.item1')}</li>
            <li>{t('privacy.usage.security.item2')}</li>
            <li>{t('privacy.usage.security.item3')}</li>
          </ul>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('privacy.storage.title')}</h2>
          
          <h3>{t('privacy.storage.data.title')}</h3>
          <ul>
            <li>{t('privacy.storage.data.item1')}</li>
            <li>{t('privacy.storage.data.item2')}</li>
            <li>{t('privacy.storage.data.item3')}</li>
          </ul>
          
          <h3>{t('privacy.storage.retention.title')}</h3>
          <ul>
            <li>{t('privacy.storage.retention.item1')}</li>
            <li>{t('privacy.storage.retention.item2')}</li>
            <li>{t('privacy.storage.retention.item3')}</li>
          </ul>
          
          <h3>{t('privacy.storage.security.title')}</h3>
          <ul>
            <li>{t('privacy.storage.security.item1')}</li>
            <li>{t('privacy.storage.security.item2')}</li>
          </ul>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('privacy.sharing.title')}</h2>
          
          <h3>{t('privacy.sharing.providers.title')}</h3>
          <ul>
            <li><strong>{t('privacy.sharing.providers.payment.title')}</strong>: {t('privacy.sharing.providers.payment.desc')}</li>
            <li><strong>{t('privacy.sharing.providers.hosting.title')}</strong>: {t('privacy.sharing.providers.hosting.desc')}</li>
            <li><strong>{t('privacy.sharing.providers.ai.title')}</strong>: {t('privacy.sharing.providers.ai.desc')}</li>
            <li><strong>{t('privacy.sharing.providers.email.title')}</strong>: {t('privacy.sharing.providers.email.desc')}</li>
          </ul>
          
          <h3>{t('privacy.sharing.analytics.title')}</h3>
          <ul>
            <li><strong>{t('privacy.sharing.analytics.google.title')}</strong>: {t('privacy.sharing.analytics.google.desc')}</li>
            <li><strong>{t('privacy.sharing.analytics.facebook.title')}</strong>: {t('privacy.sharing.analytics.facebook.desc')}</li>
            <li><strong>{t('privacy.sharing.analytics.tiktok.title')}</strong>: {t('privacy.sharing.analytics.tiktok.desc')}</li>
          </ul>
          
          <h3>{t('privacy.sharing.legal.title')}</h3>
          <p>{t('privacy.sharing.legal.desc')}</p>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('privacy.rights.title')}</h2>
          
          <p>{t('privacy.rights.intro')}</p>
          
          <h3>{t('privacy.rights.eu.title')}</h3>
          <ul>
            <li><strong>{t('privacy.rights.eu.access.title')}</strong>: {t('privacy.rights.eu.access.desc')}</li>
            <li><strong>{t('privacy.rights.eu.rectification.title')}</strong>: {t('privacy.rights.eu.rectification.desc')}</li>
            <li><strong>{t('privacy.rights.eu.erasure.title')}</strong>: {t('privacy.rights.eu.erasure.desc')}</li>
            <li><strong>{t('privacy.rights.eu.restrict.title')}</strong>: {t('privacy.rights.eu.restrict.desc')}</li>
            <li><strong>{t('privacy.rights.eu.portability.title')}</strong>: {t('privacy.rights.eu.portability.desc')}</li>
            <li><strong>{t('privacy.rights.eu.object.title')}</strong>: {t('privacy.rights.eu.object.desc')}</li>
            <li><strong>{t('privacy.rights.eu.withdraw.title')}</strong>: {t('privacy.rights.eu.withdraw.desc')}</li>
          </ul>
          
          <h3>{t('privacy.rights.california.title')}</h3>
          <ul>
            <li><strong>{t('privacy.rights.california.know.title')}</strong>: {t('privacy.rights.california.know.desc')}</li>
            <li><strong>{t('privacy.rights.california.delete.title')}</strong>: {t('privacy.rights.california.delete.desc')}</li>
            <li><strong>{t('privacy.rights.california.optout.title')}</strong>: {t('privacy.rights.california.optout.desc')}</li>
            <li><strong>{t('privacy.rights.california.nondiscrimination.title')}</strong>: {t('privacy.rights.california.nondiscrimination.desc')}</li>
          </ul>
          
          <h3>{t('privacy.rights.exercise.title')}</h3>
          <p>{t('privacy.rights.exercise.desc')}</p>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('privacy.cookies.title')}</h2>
          
          <h3>{t('privacy.cookies.use.title')}</h3>
          <ul>
            <li><strong>{t('privacy.cookies.use.essential.title')}</strong>: {t('privacy.cookies.use.essential.desc')}</li>
            <li><strong>{t('privacy.cookies.use.preferences.title')}</strong>: {t('privacy.cookies.use.preferences.desc')}</li>
            <li><strong>{t('privacy.cookies.use.analytics.title')}</strong>: {t('privacy.cookies.use.analytics.desc')}</li>
            <li><strong>{t('privacy.cookies.use.marketing.title')}</strong>: {t('privacy.cookies.use.marketing.desc')}</li>
          </ul>
          
          <h3>{t('privacy.cookies.choices.title')}</h3>
          <ul>
            <li>{t('privacy.cookies.choices.item1')}</li>
            <li>{t('privacy.cookies.choices.item2')}</li>
            <li>{t('privacy.cookies.choices.item3')}</li>
            <li>{t('privacy.cookies.choices.item4')}</li>
          </ul>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('privacy.email.title')}</h2>
          
          <h3>{t('privacy.email.marketing.title')}</h3>
          <ul>
            <li>{t('privacy.email.marketing.item1')}</li>
            <li>{t('privacy.email.marketing.item2')}</li>
            <li>{t('privacy.email.marketing.item3')}</li>
          </ul>
          
          <h3>{t('privacy.email.optout.title')}</h3>
          <ul>
            <li>{t('privacy.email.optout.item1')}</li>
            <li>{t('privacy.email.optout.item2')}</li>
          </ul>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('privacy.children.title')}</h2>
          <p>{t('privacy.children.desc')}</p>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('privacy.international.title')}</h2>
          <p>{t('privacy.international.desc')}</p>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('privacy.changes.title')}</h2>
          <p>{t('privacy.changes.p1')}</p>
          <p>{t('privacy.changes.p2')}</p>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('privacy.contact.title')}</h2>
          <p>{t('privacy.contact.p1')}</p>
          <p>
            {t('privacy.contact.email')}: contact@muware.xyz<br />
            {t('privacy.contact.mail')}: BOCO, Les Catalas, 09700 Saverdun France
          </p>
        </section>
        
        <section className="legal-page__section">
          <h2>{t('privacy.ai.title')}</h2>
          
          <h3>{t('privacy.ai.openai.title')}</h3>
          <p>{t('privacy.ai.openai.p1')}</p>
          <ul>
            <li>{t('privacy.ai.openai.item1')}</li>
            <li>{t('privacy.ai.openai.item2')}</li>
            <li>{t('privacy.ai.openai.item3')}</li>
            <li>{t('privacy.ai.openai.item4')}</li>
            <li>{t('privacy.ai.openai.item5')}</li>
          </ul>

          <h3>{t('privacy.ai.policies.title')}</h3>
          <p>{t('privacy.ai.policies.p1')}</p>
          <ul>
            <li><a href="https://openai.com/policies/privacy-policy" target="_blank" rel="noopener noreferrer">{t('privacy.ai.policies.policy')}</a></li>
            <li><a href="https://openai.com/policies/terms-of-use" target="_blank" rel="noopener noreferrer">{t('privacy.ai.policies.terms')}</a></li>
          </ul>

          <h3>{t('privacy.ai.retention.title')}</h3>
          <p>{t('privacy.ai.retention.p1')}</p>
        </section>
        
        <p className="legal-page__last-updated">{t('lastUpdated')}: {t('dateUpdated')}</p>
      </main>
      
      <footer className="footer">
        <div className="container">
          <p>© 2025 AIvatar. {t('footer.rights')}</p>
          <div className="footer-links">
            <Link to={currentLang === 'fr' ? '/fr/terms-of-service' : '/terms-of-service'}>{t('footer.terms')}</Link>
            <Link to={currentLang === 'fr' ? '/fr/privacy-policy' : '/privacy-policy'}>{t('footer.privacy')}</Link>
            <a href="mailto:contact@muware.xyz">{t('footer.contact')}</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicy; 